export default class FilterPicker {
    constructor(el, options) {
        this.element = null;
        this.inputElement = null;
        this.toggle = null;

        this.onToggleClickedBound = this.onToggleClicked.bind(this);
        this.onDocumentClickBound = this.onDocumentClick.bind(this);
    };

    attach(element) {
        if (!element) {
            return;
        }
        this.element = element;
        this.toggle = this.element.querySelector('.js-filter-picker-toggle');
        this.inputElement = this.element.querySelector('.js-filter-picker-input');

        document.addEventListener('click', this.onDocumentClickBound, false);
        this.toggle.addEventListener('click', this.onToggleClickedBound, false);
    };

    detach() {
        if (!this.element) {
            return;
        }

        document.removeEventListener('click', this.onDocumentClickBound, false);
        this.toggle.removeEventListener('click', this.onToggleClickedBound, false);

        this.toggle = null;
        this.inputElement = null;
        this.element = null;
    };

    onToggleClicked(e) {
        e.preventDefault();

        if (this.element.classList.contains('-open')) {
            this.hideOptions();
        } else {
            this.showOptions();
        }
    };


    onDocumentClick(e) {
        var insideFilterPicker = false;

        var current = e.target;
        while (current instanceof HTMLElement) {
            if (current.classList.contains('js-filter-picker')) {
                insideFilterPicker = true;
                break;
            }

            current = current.parentNode;
        }

        if (!insideFilterPicker) {
            this.hideOptions();
        }
    };

    showOptions() {
        this.element.classList.add('-open');
    };

    hideOptions() {
        this.element.classList.remove('-open');
    };

    setValue(value) {
        this.inputElement.value = value;
    };
}
